export const educationData = [
    {
        id: 1,
        institution: 'Jefferson Technical and Community College',
        course: 'Graphic and Web Design',
        startYear: '2011',
        endYear: '2013'
    },
    {
        id: 2,
        institution: 'Western Kentucky University',
        course: 'Political Science',
        startYear: '2007',
        endYear: '2010'
    },
    {
        id: 3,
        institution: 'Brown School',
        course: 'High School',
        startYear: '2003',
        endYear: '2007'
    },
]